import { EventStatusType } from 'src/@types/common';
import { getStatusesFormatted } from 'src/api/Logic/DataLogic';
import fetcher from 'src/api/RequestHandler';
import { ROUTES } from 'src/api/Routes';

type sendNotificationProps = {
  notificationId: number;
  notificationType: 'email' | 'whatsapp';
  customerId: number;
};

// Rejects on a failed send (409 when no phone is linked, 502 when the
// message did not go out) so the caller's mutation can surface it.
export function sendNotification(
  values: sendNotificationProps,
): Promise<{ message: string }> {
  const { notificationId, notificationType, customerId } = values;
  const body = {
    notificationId,
    notificationType,
  };
  return fetcher()
    .post(ROUTES.POST.SEND_ALERT_TO_CUSTOMER({ customerId: customerId }), body)
    .then(({ data }) => data);
}

export function fetchStatuses(): Promise<EventStatusType[]> {
  const promise = fetcher()
    .get(ROUTES.GET.GET_STATUSES)
    .then(({ data }) => {
      return getStatusesFormatted(data);
    })
    .catch(() => {
      return [];
    });

  return promise;
}
